import { Input } from 'antd';
import React, { FC } from 'react';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import styles from '@/presentation/components/tapd-info/index.module.scss';

export const RenderInput: FC<{
  name: string | null | undefined,
  label: string | null | undefined,
  value: string | number | null | undefined,
  getNewFields: (changeValue: string | number, name?: string | null) => void,
  labelWidth?: string,
  must?: number | null | undefined, // 是否必填 0: 非必填 1: 必填
  inputWidth?: string,
  style?: React.CSSProperties,
}> = ({
  name,
  label,
  value,
  inputWidth,
  getNewFields,
  labelWidth,
  must,
  style,
}) => (
  <div style={{ display: 'flex', marginBottom: '20px', width: '300px', ...style }}>
    <span className={styles.overflow} style={labelWidth ? { width: labelWidth } : undefined}>
      {must === 1 && <span style={{ color: 'red', marginRight: '2px' }}>*</span>}
      {hintChildren(label, label)}
    </span>
    <Input
      value={value ?? ''}
      style={{
        width: inputWidth ?? '200px',
        borderRadius: '3px',
      }}
      onChange={(e: any) => {
        getNewFields(e.target.value, name);
      }}
    />
  </div>
);
